import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/primitives'
import { FLYWAY_REGION_OPTIONS } from '@/shared/config'

type FlywaySelectProps = {
  id?: string
  value: string
  onValueChange: (value: string) => void
  error?: string
  disabled?: boolean
  label?: string
  required?: boolean
}

function FlywaySelect({
  id,
  value,
  onValueChange,
  error,
  disabled,
  label = 'Flyway region',
  required,
}: FlywaySelectProps) {
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>
        {label}
        {required ? ' *' : null}
      </Label>
      <Select value={value} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger id={id} aria-label={label}>
          <SelectValue placeholder="Select flyway" />
        </SelectTrigger>
        <SelectContent>
          {FLYWAY_REGION_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error ? (
        <p role="alert" className="text-xs text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  )
}

export { FlywaySelect }
export type { FlywaySelectProps }
